import { priceVatCalc, calcPrice, DataLayer } from '@grandvisionhq/analytics';

/**
 * Accepts an array of specification names and returns the first hit it finds or empty string
 * Example: ['materialUnlocalized', 'material'] -> returns unlocalized material value or fallbacks to material or empty string
 */ const getVariantSpecification = (specificationNames, variant)=>{
    for (const name of specificationNames){
        const spec1 = variant.specifications.find((spec)=>spec.specificationAttribute === name
        );
        if (spec1) {
            return spec1.value.toString().toLowerCase();
        }
    }
    return '';
};
const getSharedProductDetailEventTrackingAttributes = ({ activeVariant , product , purchaseType , pricePerMonth , lineItemType  })=>{
    var ref, ref1, ref2, ref3;
    const { DataLayerTypes: { PurchaseType , Stock , BrandType , LineItemType  } ,  } = DataLayer;
    // metric140
    const originalPrice = activeVariant.price.originalPrice.amount;
    const discountedPrice = (ref = activeVariant.price.discountedPrice) === null || ref === void 0 ? void 0 : ref.price.amount;
    // metric142
    let metric142 = '';
    const vatRate = product === null || product === void 0 ? void 0 : (ref1 = product.taxCategory) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rate) === null || ref2 === void 0 ? void 0 : ref2.amount;
    if (vatRate) {
        const { vatAmount  } = discountedPrice ? priceVatCalc(discountedPrice, vatRate) : priceVatCalc(originalPrice, vatRate);
        metric142 = calcPrice(vatAmount, false);
    }
    /*
   Note: Contact lenses are not yet migrated to V2
   Contact lenses subscription pricing
  */ const monthlyPriceOnSubscription = pricePerMonth && purchaseType === PurchaseType.CLBBSubscription ? pricePerMonth : undefined;
    // metric price
    const price = monthlyPriceOnSubscription || discountedPrice || originalPrice || undefined;
    // metric140
    const previousPrice = monthlyPriceOnSubscription || originalPrice || undefined;
    // metric141
    const discountedAmount = discountedPrice && originalPrice - discountedPrice || 0;
    // dimension190
    const erpId = getVariantSpecification([
        'erpId'
    ], activeVariant);
    // dimension193
    let dimension193 = '';
    const exclusiveBrand = getVariantSpecification([
        'exclusiveBrand'
    ], activeVariant);
    if (exclusiveBrand !== undefined) {
        dimension193 = exclusiveBrand ? BrandType.OwnBrand : BrandType.ExternalBrand;
    }
    // dimension194
    const isInStock = ((ref3 = activeVariant.stock) === null || ref3 === void 0 ? void 0 : ref3.stockCount) > 0;
    return {
        name: activeVariant.displayName,
        id: activeVariant.sku || '',
        price: calcPrice(price, false),
        dimension143: purchaseType,
        dimension144: lineItemType || LineItemType.Single,
        dimension145: 'true',
        dimension190: erpId,
        dimension193,
        dimension194: isInStock ? Stock.InStock : Stock.OutOfStock,
        metric140: calcPrice(previousPrice, false),
        metric141: calcPrice(discountedAmount, false),
        metric142
    };
};

export { getSharedProductDetailEventTrackingAttributes, getVariantSpecification };
//# sourceMappingURL=get-shared-product-detail-event-tracking-attributes.js.map
